/* eslint-disable no-unused-expressions */
export var reference_id = {
  name: 'reference_id',
  type: 'input'
};
export var cof_transaction_identifier = {
  name: 'credential_on_file_transaction_identifier',
  type: 'input'
};
export var cof_settlement_date = {
  name: 'credential_on_file_settlement_date',
  type: 'input'
};
export function vtSectionSelectors(features) {
  var _features$travel, _features$shipping_ad;

  var terminal_sections = ['#billing_address_wrapper', '#customer_information_wrapper'];

  if (features !== null && features !== void 0 && (_features$travel = features.travel) !== null && _features$travel !== void 0 && _features$travel.visible) {
    terminal_sections.push('.travel-container');
  }

  if (features !== null && features !== void 0 && (_features$shipping_ad = features.shipping_address) !== null && _features$shipping_ad !== void 0 && _features$shipping_ad.visible) {
    terminal_sections.push('#shipping-address-wrapper');
  }

  return terminal_sections.toString();
}
export var vt_fields = [{
  name: 'customer_email',
  type: 'input',
  required: false
}, {
  name: 'customer_phone',
  type: 'input',
  required: false
}, {
  name: 'billing_address_first_name',
  type: 'input',
  required: false
}, {
  name: 'billing_address_last_name',
  type: 'input',
  required: false
}, {
  name: 'billing_address_address1',
  type: 'input',
  required: false
}, {
  name: 'billing_address_address2',
  type: 'input',
  required: false
}, {
  name: 'billing_address_zip_code',
  type: 'input',
  required: false
}, {
  name: 'billing_address_city',
  type: 'input',
  required: false
}, {
  name: 'billing_address_state',
  type: 'input',
  required: false
}, {
  name: 'billing_address_country',
  type: 'select',
  required: false
}, {
  name: 'cvv',
  type: 'input',
  required: false
}, {
  name: 'expiration_month',
  type: 'select',
  required: false
}, {
  name: 'card_number',
  type: 'input',
  required: true
}, {
  name: 'card_holder',
  type: 'input',
  required: true
}];
export function makeField(field) {
  var input = $(field.type + '[id$="' + field.name + '"]');
  var wrapper = input.parents('.form-group, .non-referenced-recurring-wrapper');
  var label = wrapper.find('label');
  return {
    input: input,
    wrapper: wrapper,
    label: label,
    visible: function visible() {
      input.removeAttr('disabled');
      $(wrapper).removeClass('hidden');
    },
    hidden: function hidden() {
      input.attr('disabled', true);
      $(wrapper).addClass('hidden');
    },
    optional: function optional() {
      input.removeAttr('required');
      label.removeClass('required');
    },
    required: function required() {
      this.visible();
      input.attr('required', true);
      label.addClass('required');
    }
  };
}

function subsequent(features) {
  var supportsRecurringWithoutReference = features.recurring_without_reference.visible;
  var supportsSubsequentRecurring = features.subsequent_recurring.visible;
  makeField(reference_id).required();

  if (supportsRecurringWithoutReference && supportsSubsequentRecurring && !features.split_payments.visible) {
    $('#credential_on_file_params').removeClass('hidden');
    makeField(cof_settlement_date).required();
    makeField(cof_transaction_identifier).required();
  } else {
    $('#credential_on_file_params').addClass('hidden');
    makeField(cof_settlement_date).hidden();
    makeField(cof_transaction_identifier).hidden();
  }
  /*
    When the recurring type "subsequent" is chosen and the reference id value is empty,
    all fields that are required should become required,
    while the fields that are not required should be visible.
  */


  return vt_fields.forEach(function (field) {
    field.required ? makeField(field).required() : makeField(field).visible();
  });
}

function nonSubsequent(features) {
  var terminal_sections = vtSectionSelectors(features);
  $(terminal_sections).removeClass('hidden');
  var reference_id_field = makeField(reference_id);

  if (features.split_payments.visible) {
    reference_id_field.optional();
    reference_id_field.visible();
  } else {
    reference_id_field.hidden();
  }

  makeField(cof_settlement_date).hidden();
  makeField(cof_transaction_identifier).hidden();
  vt_fields.forEach(function (field) {
    field.required ? makeField(field).required() : makeField(field).visible();
  });
}

function onChange(isSubsequent, features) {
  isSubsequent ? subsequent(features) : nonSubsequent(features);
}

var VTRecurringType = {
  onChange: onChange
};
export default VTRecurringType;